module.exports = __webpack_public_path__ + "static/intertec_screen_4-32306a84946694737d638273f76cc1ef.jpg";